import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";

import { useAuthenticationPreflight } from "Components/Generic/Authentication";
import { hasElements } from "Utils/Array";
import { hasEveryRelevantProject } from "Utils/Relevance";
import { duplicateCheckStart } from "Store/Actions";
import { selectSelectedOrActiveProjectIds, selectSelectedOrActiveProjects } from "../../../Store/Selectors/Projects";
import { IAction } from "./IAction";

export function useDuplicateCheck(): [boolean, IAction] {
  const dispatch = useDispatch();
  const { preflightAuthentication } = useAuthenticationPreflight();
  const selectedProjects = useSelector(selectSelectedOrActiveProjects);
  const selectedProjectIds = useSelector(selectSelectedOrActiveProjectIds);
  const allowDuplicateCheck = hasElements(selectedProjects) && selectedProjects.length <= 10 && hasEveryRelevantProject(selectedProjects);

  const onDuplicateCheck = useCallback(async () => {
    if (!allowDuplicateCheck) {
      return;
    }

    await preflightAuthentication();
    dispatch(duplicateCheckStart(selectedProjectIds));
  }, [allowDuplicateCheck, dispatch, preflightAuthentication, selectedProjectIds]);

  return [allowDuplicateCheck, onDuplicateCheck];
}
